import { useState } from "react";
import GSearchField from "../libs/textfield/GSearchField";
import { usePath } from "../libs/path/PathProvider";

export default function Search(props:{className:string}){
    const {query,setQuery} = usePath()
    const [search,setSearch] = useState<string>(query["s"] as string || "")
    const onChange = (e:any) => {
        setSearch(e.target.value)
        setQuery({s:e.target.value})
    }
    const onClear = () => {
        setSearch("")
        setQuery({s:null})
    }
    return <div id="search" className={props.className}>
        <GSearchField id="textSearch" onChange={onChange} value={search} placeholder="search" fullWidth={true} onClear={onClear} name="search" autoComplete="search"/>
    </div>
}